import React from 'react';
import { Form } from 'antd';

import { QUERY_KEYS } from '@/utils/query-keys';
import { useUpdateDataExtraction } from '@/hooks';
import { useQueryClient } from '@tanstack/react-query';
import { useDataExtractionReport } from '@/context/DataExtractionReport';
import { StepFooterButtons } from '@/components/Settings/DataExtraction/components/StepFooterButtons';

const { useFormInstance } = Form;

export function Footer() {
	const form = useFormInstance();
	const queryClient = useQueryClient();
	const { dataExtractionReport, onPreviousStep, onNextStep } = useDataExtractionReport();
	const { isLoading: isUpdatingLoading, mutateAsync: updateDataExtraction } = useUpdateDataExtraction();

	async function handleUpdateDataExtraction(): Promise<void> {
		if (!dataExtractionReport?.id) return;
		const values = await form.validateFields();

		const customReportTypeId = values.reports?.custom_report_type_id;

		const payload = {
			id: dataExtractionReport?.id!,
			organization_id: dataExtractionReport?.organization_id!,
			company_id: dataExtractionReport?.company_id!,
			custom_report_id: customReportTypeId || dataExtractionReport?.custom_report_id,
			has_action_plan_extraction: Boolean(values.reports?.has_action_plan_extraction),
			current_step_sequence: 2
		};

		await updateDataExtraction(payload);
		await queryClient.invalidateQueries([QUERY_KEYS.GET_DATA_EXTRACTION]);
		onNextStep();
	}

	async function handleOnSubmit(): Promise<void> {
		await handleUpdateDataExtraction();
	}

	function handleOnCancel(): void {
		onPreviousStep();
	}

	return (
		<StepFooterButtons
			onSubmit={handleOnSubmit}
			onCancel={handleOnCancel}
			isLoadingNextButton={isUpdatingLoading}
		/>
	);
}
